import { atom } from "recoil"

export const QUERY_ERROR_CODES = [
  `CREDIT_APPLICATION_FAILED`,
  `UNAUTHORIZED`,
  `FORBIDDEN`,
  `VALIDATION_ERROR`,
  `EXTERNAL_SERVICE_ERROR`,
  `GOODLEAP_SERVICE_ERROR`,
  `INTERNAL_SERVER_ERROR`,
] as const

export const queryErrorNotificationState = atom<
  {
    code: string
    howToFix?: string
    message: string
  }[]
>({
  key: `queryErrorNotificationState`,
  default: [],
})
